import TripFlightPassengerSeatInfo from './trip-flight-passenger-seat-info-component';
import TripFlightPassengerSeatInfoService from './trip-flight-passenger-seat-info-service';

import './trip-flight-passenger-seat-info.scss';

const MODULE_NAME = 'App.Trip.trip-flight-passanger-seat-info';
const module = angular.module(MODULE_NAME, [])
    .directive(TripFlightPassengerSeatInfo.DIRECTIVE_NAME, TripFlightPassengerSeatInfo)
    .service('tripFlightPassengerSeatInfoService', TripFlightPassengerSeatInfoService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-flight-passenger-seat-info/trip-flight-passenger-seat-info-module.js